import { Conversations } from '../../redux/features/conversations/ConversationsState';

export const useIsChatLocked = (conversations: Conversations, selectedId: string) => {
    try {
        if (!selectedId || !conversations[selectedId]) {
            return { isLockedChat: false, lockReason: '' };
        }

        return { isLockedChat: !!conversations[selectedId].lockDate, lockReason: conversations[selectedId].lockReason };
    } catch (error) {
        console.error('Error in useIsChatLocked:', error);
        return { isLockedChat: false, lockReason: '' };
    }
};
